import { useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ModalComponent from '@components/Modal/ModalComponent';
import Add from './Add';
import Loading from '@components/Shared/Loader/Loading';
import NtxTable from '@components/DataTable/NtxTable';
import useGetBrandList from '@hooks/INV/Brand/useGetBrandList';
import Update from './Update';
import { type BrandModels } from '@store/INV/Brands/BrandModels';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

const Index = () => {
  const { HasPermission } = usePermissions();

  const [data, setData] = useState<BrandModels>();
  const { t, i18n } = useTranslation();

  const { BrandList, error, loading } = useGetBrandList();
  const columns = [
    { title: t('Name'), key: 'name' },
    { title: t('Description'), key: 'description' },
    { title: '', key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = BrandList?.map(item => {
    let rowClass;

    return {
      name: i18n.language === 'en' ? item.name : item.name2,
      description: item.description,
      action: (
        <>
          <button
            hidden={!HasPermission('INVEditBrand')}
            type='button'
            className='btn btn-outline-theme'
            data-bs-toggle='modal'
            data-bs-target='#Upfate'
            onClick={() => setData(item)}
          >
            <i className='fas fa-lg fa-edit me-2'></i>
            {t('Edit')}
          </button>
        </>
      )
    };
  });

  return (
    <>
      <div>
        <div className='d-flex align-items-center'>
          <Breadcrumb
            BreadcrumbList={[
              {
                name: 'Home',
               link: ':moduleHome'
              },
              {
                name: 'Brand',
                link: null
              }
            ]}
            PageName={t('Brand')}
          />

          <div className='ms-auto'>
            <Link
              hidden={!HasPermission('INVAddBrand')}
              to=''
              className='btn me-1 btn-theme'
              data-bs-toggle='modal'
              data-bs-target='#Add'
            >
              <i className='fa fa-lg fa-plus-circle fa-fw me-1'></i>
               {t('NewBrand')}
            </Link>
          </div>
        </div>
        <Card>
          <Loading loading={loading} error={error}>
            <CardBody>
              <NtxTable
                data={tableData || []}
                columns={columns}
                dataPerPage={10}
                theadClass=''
                tableClass='table text-nowrap table-hover '
                enableSearch
                showRecordsSelector
              />
            </CardBody>
          </Loading>
        </Card>

        <ModalComponent title={t('NewBrand')} id='Add' size='lg'>
          {<Add />}
        </ModalComponent>

        <ModalComponent title={t('EditBrand')}  id='Upfate' size='lg'>
          {data && <Update data={data} />}
        </ModalComponent>
      </div>
    </>
  );
};

export default Index;
